import { FeedbackListFragment } from "__generated__/types";
import { graphQlDateTimeToDate } from "common/dates";

// TODO: Switch to specific fragment if we get issues with types.
export function getFeedbackTitle(data: FeedbackListFragment): string {
  const elm = data.givenOn;

  if (!elm) {
    const { body } = data.messages[0];

    if (!body) {
      return "Tittelen er slettet";
    } else {
      return body.content.substring(0, 20) + "...";
    }
  }

  switch (elm.__typename) {
    case "FeedbackGivenOnFolder":
      return elm.folder.title;
    case "FeedbackGivenOnKurssloeyfe":
      return elm.kurssloeyfe.title;
    case "FeedbackGivenOnSimulationCase":
      return elm.simulationCase.title;
    default:
      return "Ukjent";
  }
}

export function sortFeedbackList(
  a: FeedbackListFragment,
  b: FeedbackListFragment,
): number {
  const aDate = graphQlDateTimeToDate(a.messages[0]?.submittedAt);
  const bDate = graphQlDateTimeToDate(b.messages[0]?.submittedAt);

  return bDate.getTime() - aDate.getTime();
}

export function isAnswered(data: FeedbackListFragment): boolean {
  return (
    data.messages[0].submittedBy?.id !=
    data.messages[data.messages.length - 1].submittedBy?.id
  );
}
